import { render, staticRenderFns } from "./ImgCheckbox.vue?vue&type=template&id=3a3fe34a&scoped=true&"
import script from "./ImgCheckbox.vue?vue&type=script&lang=js&"
export * from "./ImgCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./ImgCheckbox.vue?vue&type=style&index=0&id=3a3fe34a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3fe34a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3fe34a')) {
      api.createRecord('3a3fe34a', component.options)
    } else {
      api.reload('3a3fe34a', component.options)
    }
    module.hot.accept("./ImgCheckbox.vue?vue&type=template&id=3a3fe34a&scoped=true&", function () {
      api.rerender('3a3fe34a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/checkbox/ImgCheckbox.vue"
export default component.exports